import type { AssetTypeTemplateDuplicateButtonProps } from "./asset-type-template-duplicate-button.type";

import { ModelDuplicateButton } from "@/modules/model-duplicate";

import { AssetTypeTemplateDuplicateForm } from "../asset-type-template-duplicate-form";

const AssetTypeTemplateDuplicateButton = ({
  template,
  ...buttonProps
}: AssetTypeTemplateDuplicateButtonProps) => {
  return (
    <ModelDuplicateButton
      {...buttonProps}
      modelKey="technicalform"
      form={<AssetTypeTemplateDuplicateForm template={template} />}
    />
  );
};

export default AssetTypeTemplateDuplicateButton;
